import { GetUserInfo } from '@api'
import { localStoragePackage, getQueryString } from '@libs/util'
export default {
  state: {
    ticket: '',
    userName: '',
    userID: ''
  },
  mutations: {
    setTicket (state, val) {
      state.ticket = val
    },
    setUser (state, { name, nickname, papersnumber }) {
      state.userName = name || nickname
      state.userID = papersnumber
    }
  },
  getters: {},
  actions: {
    async setTicket ({ commit }, val) {
      commit('setTicket', val)
    },
    async setUser ({ commit }) {
      try {
        const ticket = getQueryString('ticket') || localStoragePackage('get', 'ticket')
        if (ticket) {
          localStoragePackage('set', 'ticket', ticket)
        } else {
          return
        }
        const { data: { Code, Msg } } = await GetUserInfo({ ticket })
        if (Code) {
          commit('setUser', Msg)
        } else {
          localStoragePackage('del', 'ticket')
        }
      } catch (e) {
        console.error(e)
      }
    }
  }
}